/* eslint-disable max-classes-per-file*/
export class AddressFormatValueConverter {
	public toView(address: Address) {
		let addressString = '';
		let suburbStatePostcodeString = '';

		if (!address) {
			return addressString;
		}

		if (address.line1 && address.line1.trim() !== '') {
			addressString += address.line1 + '\n';
		}
		if (address.line2 && address.line2.trim() !== '') {
			addressString += address.line2 + '\n';
		}
		if (address.suburb && address.suburb.trim() !== '') {
			suburbStatePostcodeString += address.suburb + ' ';
		}
		if (address.state && address.state.trim() !== '') {
			suburbStatePostcodeString += address.state + ' ';
		}
		if (address.postcode && address.postcode.trim() !== '') {
			suburbStatePostcodeString += address.postcode;
		}
		if (suburbStatePostcodeString.trim() !== '') {
			addressString += suburbStatePostcodeString + '\n';
		}
		if (address.countryCode && address.countryCode.trim() !== '') {
			addressString += address.countryCode;
		}

		return addressString;
	}
}

export class Address {
	public line1: string;
	public line2: string;
	public suburb: string;
	public state: string;
	public postcode: string;
	public countryCode: string;

	constructor(
		line1: string,
		line2: string,
		suburb: string,
		state: string,
		postcode: string,
		countryCode: string,
	) {
		this.line1 = line1;
		this.line2 = line2;
		this.suburb = suburb;
		this.state = state;
		this.postcode = postcode;
		this.countryCode = countryCode;
	}
}
